import React, { useEffect, useState } from "react";

import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input, Tooltip } from "antd";

import styles from "./styles.module.scss";

export interface NumberInputProps {
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  onChange?: (value: number) => void;
  decrementDisabledMessage?: string;
  incrementDisabledMessage?: string;
}

export const NumberInput: React.FC<NumberInputProps> = (props: any) => {
  const { decrementDisabledMessage, incrementDisabledMessage, ...inputProps } = props;

  const [state, setState] = useState<number>(0);

  const currentValue = props.value ?? state;
  const incrementDisabled = props?.max <= currentValue;
  const incrementMessage = (incrementDisabled ? incrementDisabledMessage : "") ?? "";
  const decrementDisabled = props?.min >= currentValue;
  const decrementMessage = (decrementDisabled ? decrementDisabledMessage : "") ?? "";

  const handleOnChange = (f: (value: number, step: number) => number) => {
    const newValue = f(currentValue, props.step ?? 1);
    setState(newValue);
    props?.onChange(newValue);
  };
  useEffect(() => {
    if (props.min && props.min > currentValue) {
      setState(props.min);
      props?.onChange(props.min);
    }
    if (props.max && props.max < currentValue) {
      setState(props.max);
      props?.onChange(props.max);
    }
  }, [props.min, props.max, currentValue, props]);

  const handleIncrement = () => handleOnChange((value, step) => value + step);
  const handleDecrement = () => handleOnChange((value, step) => value - step);

  return (
    <div className={styles.inputWrapper}>
      <Tooltip title={incrementMessage}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          shape="circle"
          size="small"
          onClick={handleIncrement}
          disabled={incrementDisabled}
        />
      </Tooltip>
      <Input type="number" {...inputProps} value={currentValue} onChange={undefined} readOnly />
      <Tooltip title={decrementMessage}>
        <Button
          type="primary"
          icon={<MinusOutlined />}
          shape="circle"
          size="small"
          onClick={handleDecrement}
          disabled={decrementDisabled}
        />
      </Tooltip>
    </div>
  );
};
